// ValidationContext.jsx
import React, { createContext, useContext, useState } from 'react';

const ValidationContext = createContext();

export const ValidationProvider = ({ children }) => {
    const [validators, setValidators] = useState([]);

    const registerValidator = (validator) => {
        setValidators((prevValidators) => [...prevValidators, validator]);
    };

    const validateAllFields = () => {
        console.log("ALL VALIDATORS CALLED");
        console.log(validators.length);
        return validators.every((validator) => validator());
    };

    return (
        <ValidationContext.Provider value={{ registerValidator, validateAllFields }}>
            {children}
        </ValidationContext.Provider>
    );
};

export const useValidation = () => {
    const context = useContext(ValidationContext);
    if (!context) {
        throw new Error("useValidation must be used within a ValidationProvider");
    }
    return context;
};
